import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {AuthorizationService} from '../authorization.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {
  constructor(
    private authorizationService: AuthorizationService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot,
              _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const permission = route.data.permission as string;
    if (!permission) return of(true);

    const permissionQueryParams = route.data.permissionQueryParams as string[] | undefined;
    const permissionRequired = !permissionQueryParams?.length
      || permissionQueryParams.some(queryParam => route.queryParamMap.has(queryParam));
    if (!permissionRequired) return of(true);

    return this.authorizationService.havePermission(permission).pipe(
      map(havePermission => havePermission
        ? true
        : this.router.createUrlTree(['/unauthorized-access']))
    );
  }
}
